import React from 'react';
import Grid from '@material-ui/core/Grid';
import { FeaturedDocsCard, HomePageStarredEntities, HomePageToolkit } from '@backstage/plugin-home';

import { HomePageSearchBar } from '@backstage/plugin-search';
import { Content, Page } from '@backstage/core-components';
import useStyles from './makeStyles';
import useLogoStyles from './makeLogoStyles';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import figmaLogo from './toolkit/figma.svg';
import grafanaLogo from './toolkit/grafana.svg';
import graylogLogo from './toolkit/graylog.svg';
import jiraLogo from './toolkit/jira.svg';
import sonarqubeLogo from './toolkit/sonarqube.svg';
import storybookLogo from './toolkit/storybook.svg';
import stackoverflowLogo from './toolkit/stackoverflow.svg';
import gitlabLogo from './toolkit/gitlab.svg';
import confluenceLogo from './toolkit/confluence.svg';
import githubLogo from './toolkit/github-octocat-svgrepo-com.svg';


export const HomePage = () => {
  const classes = useStyles();
  const {

  } = useLogoStyles();
  return (<SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center" spacing={6}>

            <Grid container item xs={12} justifyContent="center">
              <HomePageSearchBar InputProps={{
              classes: {
                root: classes.searchBarInput,
                notchedOutline: classes.searchBarOutline
              }
            }} placeholder="Search" />
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <HomePageStarredEntities />
              </Grid>
              <Grid item xs={12} md={6}>
                <FeaturedDocsCard filter={{
                  'metadata.tags': ['golden-path'],
                }} />
              </Grid>
              <Grid item xs={12} md={12}>
                <HomePageToolkit
                    tools={[
                      {
                        url: 'https://gitlab.seepex.com/',
                        label: 'Gitlab',
                        icon:  <img src={gitlabLogo} alt="Gitlab" width={24} height={24} />,
                      },
                      {
                        url: 'http://10.164.0.77/?branch=master',
                        label: 'GitLab Pipeline Dashboard',
                        icon:  <img src={gitlabLogo} alt="Gitlab" width={24} height={24} />,
                      },
                      {
                        url: 'https://seepex.atlassian.net/wiki',
                        label: 'Confluence',
                        icon:  <img src={confluenceLogo} alt="Figma" width={24} height={24} />,
                      },
                      {
                        url: 'https://seepex.atlassian.net/jira/',
                        label: 'Jira',
                        icon: <img src={jiraLogo} alt="Jira" width={24} height={24} />,
                      },
                      {
                        url: 'https://sonar.seepex.com/',
                        label: 'SonarQube',
                        icon: <img src={sonarqubeLogo} alt="SonarQube" width={24} height={24} />,
                      },
                      {
                        url: 'http://storybook.gcloud.spx/',
                        label: 'Storybook',
                        icon: <img src={storybookLogo} alt="Storybook" width={24} height={24} />,
                      },
                      {
                        url: 'https://irco.grafana.net/',
                        label: 'Grafana',
                        icon: <img src={grafanaLogo} alt="Grafana" width={24} height={24} />,
                      },
                      {
                        url: 'http://graylog.gcloud.spx/',
                        label: 'Graylog',
                        icon:<img src={graylogLogo} alt="Graylog" width={24} height={24} />,
                      },
                      {
                        url: 'https://www.figma.com/design/YJNvFVNaPlFkq7j1MyU4Py/Seepex?node-id=8806-438607',
                        label: 'Figma',
                        icon:  <img src={figmaLogo} alt="Figma" width={24} height={24} />,
                      },
                      {
                        url: 'https://stackoverflowteams.com/c/ir-digital/',
                        label: 'Stackoverflow',
                        icon: <img src={stackoverflowLogo} alt="Stackoverflow" width={24} height={24} />,
                      },                   
                      {
                        url: 'https://github.com/ir-digital',
                        label: 'Github IR Digital',
                        icon: <img src={githubLogo} alt="Github" width={24} height={24} />,
                      }
                    ]}
                  />
              </Grid>
            </Grid>
          </Grid>  
        </Content>
      </Page>
    </SearchContextProvider>);
}
